import ReactGA from 'react-ga4';

const PROD_GA_MEASUREMENT_ID = "G-HYVELKBLMR"; // For all other environments
const DEV_GA_MEASUREMENT_ID = "G-X15S77P4M3"; // For local testing

export default function gaInitialize() {

  const devOptions = {
    testMode: false,
    gtagOptions: {
      gtagUrl: `https://www.googletagmanager.com/gtag/js?id=${DEV_GA_MEASUREMENT_ID}`,
    }
  };
  const sharedOptions = {
    gtagOptions: {
      gtagUrl: `https://www.googletagmanager.com/gtag/js?id=${PROD_GA_MEASUREMENT_ID}`,
    }
  };

  if (location.hostname === "localhost" || location.hostname === "127.0.0.1") {
    ReactGA.initialize(DEV_GA_MEASUREMENT_ID, {...devOptions});
  } else { // otherwise, initialize google analytics
    ReactGA.initialize(PROD_GA_MEASUREMENT_ID, {...sharedOptions});
  }
}